import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlutterDashIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flutter_dash"}/>
}
